import styles from './Politicas.module.css';

export const Politicas = () => {
  return (
    <>
      <div className="row">
          <div className="col">
              <div className={styles.innerPanel}>
                  <p className={styles.subheader}>Aviso de privacidad</p>
                  <p className={styles.text}>En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y su Reglamento, así como de las disposiciones locales aplicables, [Nombre de la Clínica/Empresa] pone a tu disposición el siguiente Aviso de Privacidad, en relación con el uso y manejo de tus datos personales en nuestro expediente electrónico especializado en alergias:</p>
                  <p className={styles.text}>**Responsable de los Datos Personales**: [Nombre de la Clínica/Empresa] es responsable del tratamiento de tus datos personales, con domicilio en [Dirección].</p>
                  <p className={styles.text}>**Datos Personales Recabados y Finalidades del Tratamiento**: Los datos personales que recabamos y tratamos incluyen, pero no se limitan a: nombre, edad, género, dirección, teléfono, correo electrónico, antecedentes médicos, resultados de estudios ...</p>
              </div>
          </div>
      </div>
    </>
  )
}
